<template>
	<div class="ui input form-group">
		<div class="password-wrapper">
			<input
				:id="id"
				class="form-input"
				:type="showPassword ? 'text' : 'password'"
				:placeholder="placeholder != null ? placeholder : label"
				:value="value"
				@input="changeValue($event)"
			/>
			<button
				type="button"
				class="toggle-password-btn"
				@click="togglePasswordVisibility"
			>
				<img
					v-if="showPassword"
					src="@/assets/eye-solid.png"
					alt="Hide Password"
				/>
				<img
					v-else
					src="@/assets/eye-slash-solid.png"
					alt="Show Passwoed"
				/>
			</button>
		</div>
		<label
			class="form-label"
			:for="id"
			>{{ label }}</label
		>
	</div>
</template>

<script>
export default {
	props: {
		id: String,
		label: String,
		placeholder: String,
		value: String,
	},
	data() {
		return {
			showPassword: false, // Controla a visibilidade da senha
		}
	},
	methods: {
		changeValue(e) {
			this.$emit('input', e.target.value)
		},
		togglePasswordVisibility() {
			this.showPassword = !this.showPassword
		},
	},
}
</script>

<style scoped>
.ui.input {
	flex-direction: column-reverse;
	width: 100%;
	margin-bottom: 0.4rem;
	position: relative;
}

.password-wrapper {
	position: relative;
	width: 100%;
}

/* Estilos originais do input, sem alteração */
.form-input {
	font-size: 0.75rem;
	width: 100%;
	padding: 0.4rem;
	border-radius: 5px;
	padding-left: 0.65rem;
	outline: none;
}

/* Botão posicionado dentro do input, sobreposto à direita */
.toggle-password-btn {
	position: absolute;
	right: 0.5rem;
	top: 50%;
	transform: translateY(-50%);
	background: none;
	border: none;
	cursor: pointer;
	font-size: 0.75rem;
	color: #007bff;
	padding: 0;
}

.form-label {
	font-size: 0.75rem;
}
</style>
